import loading from '@/images/loader.json';
import styled from '@emotion/styled';
import { Player } from '@lottiefiles/react-lottie-player';
import { Typography } from '@mui/material';
import { PromptContainer } from './common';

interface Props {
    loadingText: string;
}

const Container = styled(PromptContainer)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    height: 160px;
`;

const LoadingAnimation = styled(Player)`
    height: 60px;
    width: 60px;
`;

function LoadingDialogContent({ loadingText }: Props) {
    return (
        <Container>
            <LoadingAnimation src={loading} autoplay loop />
            <Typography variant="body2" fontWeight={500}>
                {loadingText}
            </Typography>
        </Container>
    );
}

export default LoadingDialogContent;
